import React from 'react';

export const AltArrowDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <path
      d="M8.24668 11.0567L12.5333 6.63666C12.8007 6.35999 12.6387 5.83333 12.2867 5.83333H3.71335C3.36135 5.83333 3.19935 6.35999 3.46668 6.63666L7.75335 11.0567C7.89535 11.2033 8.10468 11.2033 8.24668 11.0567Z"
      fill="currentColor"
    />
  </svg>
);
